import React, { Suspense } from 'react';
import { Route, Navigate } from 'react-router-dom';
import { AppNavigator, PAGES, PAGES2 } from './routes';

const normalizeChildPath = (path: string): string => {
    if (path === '/') return '';
    return path.startsWith('/') ? path.slice(1) : path;
};

export const MainRouter = (
    <>
        {PAGES.map((page) => {
            const RouteElement = page.component;
            return (
                <Route
                    key={`route_${page.route}`}
                    path={normalizeChildPath(page.route)}
                    element={<Suspense fallback={<div />}><RouteElement /></Suspense>}
                />
            );
        })}
        {PAGES2.map((page) => {
            const RouteElement = page.component;
            return (
                <Route
                    key={`route_${page.route}`}
                    path={normalizeChildPath(page.route)}
                    element={<Suspense fallback={<div />}><RouteElement /></Suspense>}
                />
            );
        })}
        {AppNavigator.map((page) => {
            const RouteElement = page.component;
            return (
                <Route
                    key={`route_${page.route}`}
                    path={normalizeChildPath(page.route)}
                    element={<Suspense fallback={<div />}><RouteElement /></Suspense>}
                />
            );
        })}
        <Route path={'*'} element={<Navigate to={'/customers'} />} />

    </>
);
